import React from 'react';
import { Coins, Mail, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="bg-[#08080c] border-t border-[#1e1e2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#D4AF37] to-[#B8960C] flex items-center justify-center shadow-lg shadow-[#D4AF37]/20">
                <Coins className="w-5 h-5 text-black" />
              </div>
              <span className="font-bold text-xl text-white">BuyMe<span className="text-[#D4AF37]">Gold</span></span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md mb-6">
              {t('disclaimer')}
            </p>
            <a
              href="mailto:hello@buymegold.com"
              className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
            >
              <Mail className="w-4 h-4" />
              hello@buymegold.com
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t('sources')}</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#calculator"
                  className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  {t('calculator')}
                </a>
              </li>
              <li>
                <a
                  href="#performance"
                  className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  {t('performance')}
                </a>
              </li>
              <li>
                <a
                  href="#sources"
                  className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  {t('dataSources')}
                </a>
              </li>
              <li>
                <Link
                  to="/login"
                  className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  {t('signIn')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  {t('termsOfService')}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  {t('privacyPolicy')}
                </Link>
              </li>
              <li>
                <a
                  href="https://www.lbma.org.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  LBMA <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#1e1e2e]">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {currentYear} BuyMeGold. {t('allRightsReserved')}
            </p>
            <p className="text-xs text-gray-600">
              Powered by{' '}
              <a
                href="https://emergent.sh"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#D4AF37] hover:underline"
              >
                Emergent
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
